export const focusableElements = [
    'a[href]:not([tabindex^="-"]):not([inert]):not(:is([inert] *))',
    'area[href]:not([tabindex^="-"]):not([inert]):not(:is([inert] *))',
    'input:not([disabled]):not([tabindex^="-"]):not([inert]):not(:is([inert] *))',
    'select:not([disabled]):not([tabindex^="-"]):not([inert]):not(:is([inert] *))',
    'textarea:not([disabled]):not([tabindex^="-"]):not([inert]):not(:is([inert] *))',
    'button:not([disabled]):not([tabindex^="-"]):not([inert]):not(:is([inert] *))',
    'iframe:not([tabindex^="-"]):not([inert]):not(:is([inert] *))',
    '[tabindex]:not([tabindex^="-"]):not([inert]):not(:is([inert] *))',
    '[contentEditable=true]:not([tabindex^="-"]):not([inert]):not(:is([inert] *))',
];
export function focusFirstFocusableIn(parent, callback) {
    if (!parent) {
        console.warn('focusFirstFocusableIn called with null parent');
        return;
    }
    const selector = focusableElements.join(',');
    const elements = parent.querySelectorAll(selector);
    for (const element of elements) {
        // Check if element is visible
        const rect = element.getBoundingClientRect();
        const isVisible = rect.width > 0 && rect.height > 0;
        if (isVisible) {
            element.focus();
            callback?.();
            return true;
        }
    }
    return false;
}
export function retryFocusFirstFocusableIn(parent, retries = 20, delay = 250) {
    return new Promise((resolve) => {
        const attemptFocus = (attemptsLeft) => {
            if (attemptsLeft <= 0) {
                resolve();
                return;
            }
            if (focusFirstFocusableIn(parent)) {
                resolve();
            }
            else {
                setTimeout(() => attemptFocus(attemptsLeft - 1), delay);
            }
        };
        attemptFocus(retries);
    });
}
export function focus(element) {
    if (!element) {
        console.warn('focus called with null element');
        return;
    }
    const originalTabIndex = element.getAttribute('tabindex');
    element.setAttribute('tabindex', '-1');
    element.focus();
    element.addEventListener('blur', () => originalTabIndex === null
        ? element.removeAttribute('tabindex')
        : element.setAttribute('tabindex', originalTabIndex), { once: true });
}
